export default {
      id: "pinOutlined-usage",
      viewBox: "0 0 16 18",
      url: __webpack_public_path__ + "icons.svg#pinOutlined",
      toString: function () {
        return this.url;
      }
    }